// extracted by mini-css-extract-plugin
export default {"header":"GacTreatware_header__588d3","footer_controls":"GacTreatware_footer_controls__7y3KA","close_modal":"GacTreatware_close_modal__PCadg"};